// extracted by mini-css-extract-plugin
module.exports = {"root":"FeaturesFlagsFilter-module__root__1YFbm","filters-row":"FeaturesFlagsFilter-module__filters-row__3vhvK","mid":"FeaturesFlagsFilter-module__mid__20ayL"};